import { Modal } from '@/components';
import { ProfileEditForm } from './ProfileEditForm';
import { UserType } from '@/constants';

interface ProfileEditModalProps {
	showProfileEditModal: boolean;
	setShowProfileEditModal: (show: boolean) => void;
	userType: 'INSTRUCTOR' | 'COACH' | 'UNIVERSITY_STUDENT';
	formConfig: Record<string, boolean>;
}

export const ProfileEditModal = ({ showProfileEditModal, setShowProfileEditModal, userType, formConfig }: ProfileEditModalProps) => {
	return (
		<Modal
			isOpen={showProfileEditModal}
			onClose={() => setShowProfileEditModal(false)}
			showCloseButton
			variant="centered"
			size={userType === UserType.INSTRUCTOR ? 'xl' : 'md'}
			className="background-mode-modal">
			<ProfileEditForm
				closeModal={() => setShowProfileEditModal(false)}
				userType={userType}
				formConfig={formConfig}
			/>
		</Modal>
	);
};
